var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onboardingUser.allowedToSkipVideo)?_c('div',{on:{"click":_vm.skipVideoConfirm}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }